import { createFileRoute } from '@tanstack/react-router'
import { FinanceOverviewPage } from '_/features/finance/ui/pages/finance-overview-page'

export const Route = createFileRoute('/_authenticated/finance/')({
	staticData: { title: 'finance_title' },
	component: FinanceOverviewPage,
})
